import localForage from "localforage";

export const statDB = localForage.supports(localForage.INDEXEDDB) ? localForage.createInstance({
    driver      : localForage.INDEXEDDB,
    name        : 'app-usage',
    version     : 1.0,
    storeName   : 'app-usage',
    description : 'Storage for app usage statistics'
}) : null;
